import { render, staticRenderFns } from "./ModalCadastroSubstituto.vue?vue&type=template&id=76604f6e"
import script from "./ModalCadastroSubstituto.vue?vue&type=script&lang=js"
export * from "./ModalCadastroSubstituto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports